import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

interface IProps {
  onChange?: (value: any) => void,  // ← Rendre optionnel avec ?
  onSearch?: (val: any) => void,     // ← Rendre optionnel aussi
  placeholder?: string,
  data: any[],
  label: string,
  valueLabel: string
  label2?: string
  label3?: string
  defaultVal?: string
  value?: any
  disabled?: boolean
}

const SelectSearchInput = ({ onChange, onSearch, placeholder, data, label, valueLabel, label2, label3, defaultVal, value, disabled }: IProps) => {
  return (
    <Select
      disabled={disabled ? true : false}
      showSearch
      value={value}
      defaultValue={defaultVal}
      placeholder={placeholder || 'selectionner...'}
      optionFilterProp="children"
      onChange={onChange}
      onSearch={onSearch}
      filterOption={(input, option: any) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {
        data.map(item => {
          return (
            <Option key={item.id} value={item[`${valueLabel}`]}>
              {
                (label2 || label3) ?
                  item[`${label}`] + ' ' + item[`${label2}`] + ' ' + item[`${label3}`]
                  : item[`${label}`]
              }
            </Option>
          )
        })
      }
    </Select>
  );
}

export default SelectSearchInput;